import { ProductModel } from "@app/shared/services/gtm/model/product.model";

export class ECommerceDataModel {
  actionField: any;
  products: ProductModel[];
}
